import { render, staticRenderFns } from "./UploadVaccinationArea.vue?vue&type=template&id=641c0bb6&scoped=true&"
import script from "./UploadVaccinationArea.vue?vue&type=script&lang=js&"
export * from "./UploadVaccinationArea.vue?vue&type=script&lang=js&"
import style0 from "./UploadVaccinationArea.vue?vue&type=style&index=0&id=641c0bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c0bb6",
  null
  
)

export default component.exports